module.exports = __webpack_public_path__ + "static/media/image6.6dd9d82e.png";